import { Switch, useRouteMatch } from "react-router-dom";

import ContainerRoute from "@components/routing/container-route";
import IntegrationsContext from "@context/integrations.context";

import { IntegrationsList } from "./list";

export default ({ responsiveStyles = {} }) => {
  const { path } = useRouteMatch();

  return (
    <IntegrationsContext>
      <Switch>
        <ContainerRoute
          exact={true}
          path={path}
          component={IntegrationsList}
          responsiveStyles={responsiveStyles}
        />
      </Switch>
    </IntegrationsContext>
  );
};
